
export default {
  data() {
    return {
      partner: false,
    };
  },
  computed: {
    partnerLogoSrc() {
      if (this.partner) {
        return `${this.$config.partnerLogoBaseUrl}${this.partner}.png`;
      }
      return null;
    },
  },
  mounted() {
    if (this.readCookie()) {
      this.partner = this.readCookie();
    } else if (this.readQuery()) {
      const params = {
        utm_source: this.$route.query.utm_source,
        utm_medium: this.$route.query.utm_medium,
        utm_campaign: this.$route.query.utm_campaign,
      };
      if (params.utm_source === 'referralprogram') {
        return;
      }
      this.$axios({
        method: 'get',
        baseURL: '/',
        url: 'ajax/set-partner-session',
        params,
      })
        .then((result) => {
          if (result.data.result && result.data.result !== 'false') {
            this.partner = this.readQuery();
          } else {
            this.partner = false;
          }
        })
        .catch((error) => {
          // Add error handeling for failing partner links
          console.log(error);
        });
    }
  },
  methods: {
    readQuery() {
      if (this.$route.query.utm_source && this.$route.query.utm_medium && this.$route.query.utm_campaign) {
        return this.$route.query.utm_campaign;
      }
      return false;
    },
    readCookie() {
      const nameEQ = 'partnerImage=';
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i += 1) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return false;
    },
  },
};
